<template>
    <div :style="styleSlider(styleSld)">
        <div :id="id1" :style="styleSliderBtn(value, 2)" @click="choice(2)">{{option1}}</div>
        <div :id="id2" :style="styleSliderBtn(value, 0)" @click="choice(0)">{{option2}}</div>
        <div :id="id3" :style="styleSliderBtn(value, 1)" @click="choice(1)">{{option3}}</div>
    </div>
</template>

<script>

export default {
	name: "SliderWith3btn",
	props: {
		id1: String,
		id2: String,
		id3: String,
		value: Number,
		styleSld: String,
		styleOp1: String,
		styleOp2: String,
		styleOp3: String,
		styleDefault: String,
		option1: String,
		option2: String,
		option3: String
	},
	model: {
		prop: "value",
		event: "choice"
	},
	data() {
		return {
		};
	},
	methods: {
		styleSlider(style){
			return "font-size: 10px; background-color: rgba(224, 224, 224, 0.78); border-radius: 5px; display: flex; justify-content: space-between; cursor: pointer; font-weight: bold; " + style;
		},
		styleSliderBtn(value, option){
			let base = "display: flex; align-items: center; justify-content: center; border-radius: 5px; white-space: nowrap; padding: 5px 10px;";
			if(value == 2 && option == 2) return base + this.styleOp1;
			if(value == 0 && option == 0) return base + this.styleOp2;
			if(value == 1 && option == 1) return base + this.styleOp3;
			else return base + "background-color: transparent; " + this.styleDefault;
		},
		choice(value){
			//console.log(value);
			this.$emit("choice", value);
			this.$emit("btn-selected", value);
		}
	}
};
</script>

<style scoped>
</style>